import {
    AppointmentDto,
    BookingDto,
    SaveAppointmentDetailsDto,
    SaveAppointmentDto,
    SaveBookingDto
} from 'actions/bookings/BookingsDtos';
import { convertToSaveOrderDto } from 'actions/orders/OrdersConverter';
import { convertToSaveTaskDto } from 'actions/tasks/TasksDataConverter';
import moment from 'moment-timezone';
import { Appointment, SaveAppointment, SaveAppointmentDetails } from 'types/Appointment';
import { Booking, SaveBooking } from 'types/Booking';

export const convertToBooking = (bookingDataDto: BookingDto, timeZone: string): Booking => {
    const dto = (bookingDataDto as BookingDto & { booking?: BookingDto }).booking ?? bookingDataDto;
    const pendingFormsDto = dto.pending_forms;

    return {
        id: dto.id ? dto.id : 0,
        uuid: dto.uuid,
        customerId: dto.customer_id,
        marketplaceId: dto.marketplace_id,
        staffId: dto.staff_id,
        appointments: (dto.appointments || []).map(appointment =>
            convertToAppointment(appointment, timeZone)
        ),
        pendingForms: {
            hasPending: pendingFormsDto?.has_pending === true,
            token: pendingFormsDto?.token
        }
    };
};

export const convertToSaveBookingDto = (newBooking: SaveBooking): SaveBookingDto => {
    return {
        uuid: newBooking.uuid,
        customer_id: newBooking.customerId,
        marketplace_id: newBooking.marketplaceId,
        staff_id: newBooking.staffId,
        ...(newBooking.addressId !== undefined && { address_id: newBooking.addressId }),
        appointments_attributes: newBooking.appointments.map(appointment =>
            convertToSaveAppointmentDto(appointment)
        ),
        ...(newBooking.order && {
            order: convertToSaveOrderDto(newBooking.order)
        })
    };
};

export const convertToAppointment = (
    appointmentDto: AppointmentDto,
    timeZone: string
): Appointment => {
    return {
        id: appointmentDto.id,
        uuid: appointmentDto.uuid,

        customerId: appointmentDto.customer_id,
        serviceId: appointmentDto.service_id,
        petId: appointmentDto.pet_id,
        staffId: appointmentDto.staff_id,
        addressId: appointmentDto.address_id,
        createdBy: appointmentDto.created_by,

        notes: appointmentDto.notes,
        status: appointmentDto.status,
        channel: appointmentDto.channel,

        bookedAt: moment(appointmentDto.booked_at).tz(timeZone)
    };
};

export const convertToSaveAppointmentDto = (appointment: SaveAppointment): SaveAppointmentDto => {
    return {
        uuid: appointment.uuid,

        address_id: appointment.addressId,
        customer_id: appointment.customerId,
        pet_id: appointment.petId,
        service_id: appointment.serviceId,
        staff_id: appointment.staffId,
        room_unit_id: appointment.roomUnitId,
        created_by: appointment.createdBy,

        notes: appointment.notes,
        status: appointment.status,
        channel: 'online-booking',

        booked_at: appointment.bookedAt?.toISOString(),
        booking_end_at: appointment.bookingEndAt?.toISOString(),

        order_item_price: appointment.orderItemPrice,

        ...(appointment.tasks && {
            tasks_attributes: appointment.tasks.map(task => convertToSaveTaskDto(task))
        }),

        ...(appointment.details && {
            details: convertToSaveAppointmentDetailsDto(appointment.details)
        })
    };
};

const convertToSaveAppointmentDetailsDto = (
    details: SaveAppointmentDetails
): SaveAppointmentDetailsDto => {
    if ('training' in details) {
        const { sessionType, ...training } = details.training;

        return { training: { ...training, session_type: sessionType } };
    }

    return details;
};
